import { QUOTE_STATUS_COLOR_ENUM, QUOTE_KIND_COLOR_ENUM, QUOTE_STATUS_ENUM, QUOTE_KIND_ENUM } from "@modules/private/quote/data/enum/quote.enum";
import { AmortizationPeriodStatus } from "@modules/private/quote/data/interfaces/iquote.interface";
import { PaymentType } from "@modules/private/quote/data/interfaces/iquote-parameters.interface";
import { ITableCol } from "@data/interfaces/itable.interface";

export const QUOTE_KIND_OPTIONS = [
  { value: 'Puro', label: 'Puro' },
  { value: 'Financiero', label: 'Financiero' }
]

export const QUOTE_STATUS_OPTIONS = [
  { value: 'En prospección', label: 'En prospección' },
  { value: 'Aceptada', label: 'Aceptada' },
  { value: 'Cancelada', label: 'Cancelada' }
]

export const PAYMENT_TYPE_OPTIONS = [
  { value: PaymentType.FINANCED, label: 'Financiado' },
  { value: PaymentType.CASH, label: 'Contado' }
]

export const AMORTIZATION_STATUS_OPTIONS = [
  { value: AmortizationPeriodStatus.PENDING, label: 'Pendiente' },
  { value: AmortizationPeriodStatus.PAID, label: 'Pagado' },
  { value: AmortizationPeriodStatus.OVERDUE, label: 'Vencido' }
]

export const QUOTE_PARAMETERS_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'ID Parámetros', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'quote/parameters' },
  { type: 'text', field: 'client.name', header: 'Cliente', showFilter: true, dataType: 'link', linkField: 'client._id', rootLink: 'customer' },
  { type: 'text', field: 'assetsNames', header: 'Activos', showFilter: true },
  { type: 'text', field: 'provitionalClient', header: 'Cliente Provisional', showFilter: true },
  { type: 'text', field: 'provitionalAsset', header: 'Activo Provisional', showFilter: true },
  { type: 'number', field: 'assetsValue.total', header: 'Valor Total', showFilter: true, dataType: 'currency' },
  { type: 'enum', field: 'leaseType', header: 'Tipo Arrendamiento', showFilter: true, dataType: 'enum', enum: QUOTE_KIND_ENUM, enumColor: QUOTE_KIND_COLOR_ENUM, options: QUOTE_KIND_OPTIONS },
  { type: 'number', field: 'advance', header: 'Anticipo (%)', showFilter: true },
  { type: 'number', field: 'interestRate', header: 'Tasa Interés (%)', showFilter: true },
  // { type: 'number', field: 'accessoriesNames', header: 'Accesorios', showFilter: false }, //TODO: Agregar la funcion para calcular accesorios en el back
  { type: 'date', field: 'createdAt', header: 'Fecha Creación', showFilter: false },
]

export const QUOTE_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'ID Cotización', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'quote' },
  { type: 'text', field: 'client.name', header: 'Cliente', showFilter: true, dataType: 'link', linkField: 'client._id', rootLink: 'customer' },
  { type: 'text', field: 'assetsNames', header: 'Activos', showFilter: false },
  { type: 'number', field: 'assetsValue.total', header: 'Valor Activos', showFilter: true, dataType: 'currency' },
  { type: 'enum', field: 'leaseType', header: 'Tipo Arrendamiento', showFilter: true, dataType: 'enum', enum: QUOTE_KIND_ENUM, enumColor: QUOTE_KIND_COLOR_ENUM, options: QUOTE_KIND_OPTIONS },
  { type: 'number', field: 'termData.term', header: 'Término (meses)', showFilter: true },
  { type: 'number', field: 'termData.rent.total', header: 'Renta Mensual', showFilter: true, dataType: 'currency' },
  { type: 'number', field: 'termData.totalLeasePayment', header: 'Pago Total', showFilter: true, dataType: 'currency' },
  { type: 'text', field: 'accessoriesConcepts', header: 'Accesorios', showFilter: false },
  { type: 'enum', field: 'status', header: 'Estado', showFilter: true, dataType: 'enum', enum: QUOTE_STATUS_ENUM, enumColor: QUOTE_STATUS_COLOR_ENUM, options: QUOTE_STATUS_OPTIONS },
  { type: 'date', field: 'expiresAt', header: 'Fecha Expiración', showFilter: true },
]

//* El controller de quotation-parameters es @ModuleName('quotations'). Los permisos
//* originales (`quotation-parameters`, `read`, `download`, `calculate`) NO existen en
//* NINGÚN rol → estas acciones estaban ocultas para TODOS, incluido Admin. Se corrigen a
//* los permisos reales del módulo `quotations` que exige cada endpoint:
//*   VIEW/CALCULATE → get-by-id (VIEW es solo un toast; CALCULATE llama :id/calculate → get-by-id)
//*   EDIT → update · DELETE → delete
export const QUOTE_PARAMETERS_ACTIONS = [
  { icon: 'fa-regular fa-eye', action: 'VIEW', title: 'Ver Detalles', color: 'info', permission: ['quotations', 'get-by-id'] as [string, string] },
  { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary', permission: ['quotations', 'update'] as [string, string] },
  { icon: 'fa-regular fa-calculator', action: 'CALCULATE', title: 'Calcular Cotización', color: 'success', permission: ['quotations', 'get-by-id'] as [string, string] },
  { icon: 'fa-regular fa-trash-can', action: 'DELETE', title: 'Eliminar', color: 'danger', permission: ['quotations', 'delete'] as [string, string] },
];

export const QUOTE_ACTIONS = [
  { icon: 'fa-regular fa-eye', action: 'VIEW', title: 'Ver Detalles', color: 'info', permission: ['quotations', 'get-by-id'] as [string, string] },
  { icon: 'fa-regular fa-file-pdf', action: 'DOWNLOAD_PDF', title: 'Descargar PDF', color: 'warning', permission: ['quotations', 'get-by-id'] as [string, string] },
];

export const ACTIONS = [
  { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary', permission: ['quotations', 'update'] as [string, string] },
  { icon: 'fa-regular fa-trash-can', action: 'DELETE', title: 'Eliminar', color: 'danger', permission: ['quotations', 'delete'] as [string, string] },
];

export const PAYMENT_TYPE_ENUM = {
  [PaymentType.FINANCED]: 'Financiado',
  [PaymentType.CASH]: 'Contado'
}

export const PAYMENT_TYPE_COLOR_ENUM = {
  [PaymentType.FINANCED]: 'warning',
  [PaymentType.CASH]: 'success'
}

export const AMORTIZATION_STATUS_ENUM = {
  [AmortizationPeriodStatus.PENDING]: 'Pendiente',
  [AmortizationPeriodStatus.PAID]: 'Pagado',
  [AmortizationPeriodStatus.OVERDUE]: 'Vencido'
}

export const AMORTIZATION_STATUS_COLOR_ENUM = {
  [AmortizationPeriodStatus.PENDING]: 'warning',
  [AmortizationPeriodStatus.PAID]: 'success',
  [AmortizationPeriodStatus.OVERDUE]: 'danger'
}
